var _ = require('underscore/underscore');
var BasePopup = require('front/components/BasePopup/BasePopup');

var template = require('./MediaPopup.jinja');
require('./MediaPopup.less');

var CommonVideoPlayer = require('front/components/CommonVideoPlayer/CommonVideoPlayer');
var CommonVideoGallery = require('front/components/CommonVideoGallery/CommonVideoGallery');

module.exports = BasePopup.extend({

    template: template,

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'CommonVideoGallery': {selector: '.CommonVideoGallery', viewConstructor: CommonVideoGallery}
    },

    events: _.extend({
        'click .MediaPopup-back': 'closePopup'
    }, BasePopup.prototype.baseEvents),


    apiUrl: function () {
        var id = parseInt(this.slug.split('-')[0], 10);

        return Urls['front:api:media-popup'](id, 'json');
    },

    renderData: function () {
        return {
            popup: this.data || {}
        };
    },

    initialize: function (options) {
        this.options = options || {};

        this.slug = this.options.slug;
        this.hash = '' || window.app.hashMedia;

        BasePopup.prototype.initialize.call(this, options);
    },

    activate: function () {
        this.dataPopup = this.data;

        return BasePopup.prototype.activate.call(this);
    },


    onPopupShown: function () {
        this.$('.MediaPopup-video .CommonVideoPlayer').trigger('initplayer');

        return BasePopup.prototype.onPopupShown.call(this);
    },


    viewsRegistration: function () {
        var link = window.location.href;

        this.commonVideoPlayer = new CommonVideoPlayer({needNext: true});

        $('.MediaPopup-infoShare-item--facebook').on('click', function () {
            app.shareFacebook({link: link, title: this.dataPopup.title});
        }.bind(this));

        $('.MediaPopup-infoShare-item--twitter').on('click', function () {
            app.shareTwitter({link: link, title: this.dataPopup.title});
        }.bind(this));

        $('.MediaPopup-infoShare-item--mail').on('click', function () {
            app.shareMail({link: link, title: this.dataPopup.title});
        }.bind(this));

        BasePopup.prototype.viewsRegistration.call(this);
    },

    deactivate: function (params) {
        if (this.hash) {
            window.location.hash = this.hash;
        }

        this.commonVideoPlayer.destroy();
        delete this.commonVideoPlayer;

        return BasePopup.prototype.deactivate.call(this, params);
    },

    closePopup: function () {
        app.router.navigateBack();
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/MediaPopup/MediaPopup.js
// module id = 276
// module chunks = 0